import { render } from "./portabilidades.vue?vue&type=template&id=577ca1d7&scoped=true"
import script from "./portabilidades.vue?vue&type=script&lang=js"
export * from "./portabilidades.vue?vue&type=script&lang=js"

import "./portabilidades.vue?vue&type=style&index=0&id=577ca1d7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-577ca1d7"]])

export default __exports__